module.exports = __webpack_public_path__ + "img/puzzle8_1.e8fc49ab.jpg";